import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from "react-router-dom";
import { Modal, Form, Typography, Table, InputNumber, Button, Popconfirm, Row, Col, Radio } from 'antd';
import { accAdd, accMul } from '../../../util/math';
import { currency } from '../../quotationProduct/formatNumber';
import './receiveModal.less';

export default forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const { productInfo = [], settlement_mode, auto_create_bill = 0, order_no } = props.item;
  const [list, setList] = useState(productInfo.map(item => ({ ...item, delivery_info_sale_number: item.delivery_info.sale_number, receive_number: item.delivery_info.sale_number, })));
  const initialValues = list.reduce((pre, acc) => ({ ...pre, [`receive_number_${acc.id}`]: acc.delivery_info.sale_number }), {});
  const [receiveOpen, setReceiveOpen] = useState(true);
  const [billOpen, setBillOpen] = useState(false);
  const receive_number_blur = (e, record) => {
    const { id, delivery_info: { sale_number } } = record;
    const value = form.getFieldValue(`receive_number_${id}`) || 0;
    if (value > sale_number) {
      form.setFieldsValue({ [`receive_number_${id}`]: sale_number });
    }
    const newList = list.map(item => (item.id === id ? { ...item, delivery_info_sale_number: value > sale_number ? sale_number : value } : item));
    setList(newList);
  };
  const columns = [
    {
      title: '商品信息',
      dataIndex: 'product',
      key: 'product',
      render: (_, record) => {
        return <div className='receive-modal-div'>
          <div className='receive-modal-left'><img src={record.product_img} alt="" /></div>
          <div className='receive-modal-right'>
            <div className='pointer receive-modal-right-title'>{record.sku_name}</div>
            <div>规格：{record.sale_norms}</div>
          </div>
        </div>;
      }
    },
    {
      title: '单价（含税）',
      dataIndex: 'tax_inclusive_price',
      key: 'tax_inclusive_price',
      align: 'center',
      render: text => `¥${currency(text)}`
    },
    {
      title: '订单商品数量',
      dataIndex: 'sale_number',
      key: 'sale_number',
      align: 'center',
    },
    {
      title: '发货数量',
      dataIndex: 'delivery_info',
      key: 'delivery_info',
      align: 'center',
      render: c => c?.sale_number
    },
    {
      title: '*收货数量',
      dataIndex: 'delivery_info_sale_number ',
      key: 'delivery_info_sale_number ',
      align: 'center',
      render: (_, record) => {
        return <Form.Item style={{ margin: 0 }} label="" name={`receive_number_${record.id}`} rules={[{ required: true, message: '请输入收货数量!', },]}>
          <InputNumber precision={3} min={0} max={record?.delivery_info?.sale_number} onChange={(e) => receive_number_blur(e, record)} />
        </Form.Item>;
      }
    },
    {
      title: '小计',
      dataIndex: 'receive_number_total',
      key: 'receive_number_total',
      align: 'center',
      render: (_, record) => {
        const number = settlement_mode === 1 ? record.delivery_info_sale_number : record.sale_number;
        return `¥${currency(accMul(number, record.tax_inclusive_price))}`;
      }
    },
  ];

  useImperativeHandle(ref, () => ({ form, setBillOpen }));

  const receiveModalCancel = () => {
    props.setCurrentItem(undefined);
  };

  const receiveBase = async (values) => {
    const info = { ...props.item, is_manual: values.is_manual, receive_info: list.map(item => ({ ...item, receive_number: values[`receive_number_${item.id}`], })), buttonText: '确认收货' };
    props.btnClicked(info);
  };

  const receiveModalOk = async () => {
    try {
      const values = await form.validateFields();
      receiveBase(values);
      receiveModalCancel();
    } catch (error) {
      console.log('🚀 ~ receiveModalOk ~ error:', error);
    }
  };

  const receiveModalOkConfirm = async () => {
    try {
      const values = await form.validateFields();
      receiveBase(values);
      setReceiveOpen(false);
    } catch (error) {
      console.log('🚀 ~ receiveModalOk ~ error:', error);
    }
  };

  const computedTotal = () => {
    return `¥${currency(list.reduce((pre, acc) => {
      const number = settlement_mode === 1 ? acc.delivery_info_sale_number : acc.sale_number;
      return accAdd(pre, accMul(number, acc.tax_inclusive_price));
    }, 0))}`;
  };

  const goToBill = () => {
    history.push(`/basic/user/bill?order_no=${order_no}`);
  };

  return (
    <div className='receive-modal-container'>
      <Modal
        title="确认收货"
        open={receiveOpen}
        onCancel={receiveModalCancel}
        width={1000}
        getContainer={false}
        footer={
          <>
            <Button onClick={receiveModalCancel}>取消</Button>
            {auto_create_bill ? <Popconfirm
              title="收货后将自动生成对账单，是否确认收货？"
              onConfirm={receiveModalOkConfirm}
              okText="是"
              cancelText="否"
            >
              <Button type='primary'>确认收货</Button>
            </Popconfirm> : <Button type='primary' onClick={receiveModalOk}>确认收货</Button>}
          </>
        }      >
        <Form
          name="basic"
          labelCol={{ span: 8, }}
          wrapperCol={{ span: 16, }}
          initialValues={initialValues}
          form={form}
        >
          <Row gutter={24} style={{ marginBottom: 20 }}>
            <Col span={10}>请在确认订单金额无误后填写收货数量</Col>
            <Col span={14} style={{ textAlign: 'right' }}><Typography.Link>确认收货后将按实际收货数量计算商品单价、订单应付总金额等，且不可变更</Typography.Link></Col>
          </Row>
          <Table dataSource={list} columns={columns} pagination={false} rowKey='id' />
          {
            ((props.item?.purchase_platform_no && (props.item?.purchase_platform_no !== "IPP")) || (props.item?.erpInfo?.purchase_platform_no && props.item?.erpInfo?.purchase_platform_no !== "IPP")) ? <Form.Item label='采购单完成同步ERP' name='is_manual' labelCol={{ span: 4, }} rules={[{ required: true, message: '请选择同步方式!', },]}>
              <Radio.Group >
                <Radio value={0}>自动同步</Radio>
                <Radio value={1}>手动同步</Radio>
              </Radio.Group>
            </Form.Item> : null
          }
          <div style={{ textAlign: 'right' }}>商品总计：{computedTotal()}</div>
        </Form>
      </Modal>
      <Modal
        open={billOpen}
        getContainer={false}
        footer={null}
        onCancel={() => setBillOpen(false)}
      >
        <div>当前采购单已自动生成对账单</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}><Button type='primary' onClick={goToBill}>查看对账单</Button></div>
      </Modal>
    </div>
  );
});